import { Button, Dropdown, Space } from "antd";
import { ROLE_ADMIN } from "../../../constants";

const items = [
  {
    key: "1",
    label: <a> Editar </a>,
  },
  {
    key: "2",
    label: <a> Desativar </a>,
  },
];

export const ColumnsUser = (role) => {
  const table = [
    {
      title: "Nome",
      dataIndex: "name",
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
    },
  ];

  const tableDefault = [
    {
      title: "E-mail",
      dataIndex: "email",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Perfil",
      dataIndex: "profile",
      textWrap: "word-break",
      width: "15%",
      ellipsis: true,
    },

    {
      title: "Status",
      dataIndex: "activeString",
      width: "10%",
    },
  ];

  if (role == ROLE_ADMIN) {
    table.push({
      title: "CNPJ",
      dataIndex: "document",
      width: "15%",
    });
  }

  table.push(...tableDefault);
  if (role == ROLE_ADMIN) {
    table.push(
      {
        title: "Licenças",
        dataIndex: "quantityUser",
        width: "8%",
      },
      {
        title: "Valor",
        dataIndex: "licenseBrl",
        width: "8%",
      }
    );
  }

  table.push({
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <Space size="middle">
          <a onClick={() => row.edit(row)} type="primary">
            Editar
          </a>
          <a onClick={() => row.disable(row)} type="primary">
            Desativar
          </a>
        </Space>
      );
    },
  });
  return table;
};

export const ColumnsUserCsv = (role) => {
  const table = [
    {
      label: "Nome",
      key: "name",
    },
  ];

  const tableDefaut = [
    {
      label: "E-mail",
      key: "email",
    },
    {
      label: "Perfil",
      key: "profile",
    },
    {
      label: "Status",
      key: "activeString",
    },
  ];
  if (role == ROLE_ADMIN) {
    table.push({
      label: "CNPJ",
      key: "document",
    });
  }
  table.push(...tableDefaut);
  if (role == ROLE_ADMIN) {
    table.push({
      label: "Licenças",
      key: "quantityUser",
    });
    table.push({
      label: "Valor",
      key: "licenseBrl",
    });
  }
  return table;
};
